const UserModel = require("@/appModel/users/UserModel");
const DateUtil = require("@/appUtils/DateUtil");
const { getUserList } = require("./appModel/users/UserModel");

class AppViewModel {
  constructor(tenantId){
    this.tenantId = tenantId
    this.scheduledList = []
    this.closedList = []
    this.userName = ""
    this.campanyName = ""
    this.email = ""
    this.dbRows = []
  }

  static async init(tenantId) {
    let vm = new AppViewModel(tenantId)  
    return vm
  }
  
  
  async get(sk) {
    return await MeetingModel.getMeeting({sk: sk}, this.tenantId)
  }
  async update(data) {
    
    return await MeetingModel.updateMeeting(data) 
  }
  // ユーザー情報を取得
  async getUser(sub) {
    const sk = UserModel.createSk(sub)
    return await UserModel.getUser({sk: sk}, this.tenantId)
  }
  
}

module.exports = AppViewModel;